import { Routes } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { LogoutAndNavigatePublicRouteGuard } from 'src/app/core/guards/logout-and-navigate-public-route.guard';
import { OpenInOtherTabGuard } from 'src/app/core/guards/open-in-other-tab.guard';
import { LegacyRenderComponent } from '../../pages/legacy-render/legacy-render.component';

export const COMPANY_LEGACY_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/'
  },
  {
    path: 'panel', component: LegacyRenderComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      name: 'Painel',
      legacyRoute: 'empresa/painel.aspx',
      roles: ['Administrador da Empresa'],
      permissions: {
        only: 'OpportunityModuleAccess',
        redirectTo: '/unauthorized'
      },
      icon: 'home'
    },
  },
  {
    path: 'jobs', component: LegacyRenderComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      name: 'Vagas',
      legacyRoute: 'vaga/listarvagasempresa.aspx',
      roles: ['Administrador da Empresa'],
      permissions: {
        only: 'OpportunityModuleAccess',
        redirectTo: '/unauthorized'
      },
      icon: 'suitcase'
    },

  },
  {
    path: 'jobs/view', component: LegacyRenderComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      name: 'Vagas',
      legacyRoute: 'vaga/visualizar.aspx',
      roles: ['Administrador da Empresa'],
      permissions: {
        only: 'OpportunityModuleAccess',
        redirectTo: '/unauthorized'
      },
      icon: 'suitcase',
      notInHeaderMenu: true,
    },

  },
  {
    path: 'candidates', component: LegacyRenderComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      name: 'Candidatos',
      legacyRoute: 'curriculos',
      roles: ['Administrador da Empresa'],
      permissions: {
        only: 'OpportunityModuleAccess',
        redirectTo: '/unauthorized'
      },
      icon: 'black-tie'
    }
  },
  {
    path: 'internships', component: LegacyRenderComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      name: 'Estágios',
      legacyRoute: 'm/estagio/empresa',
      roles: ['Administrador da Empresa'],
      permissions: {
        only: 'InternshipModuleAccess',
        redirectTo: '/unauthorized'
      },
      icon: 'graduation-cap'
    }
  },
  {
    path: 'internships/view', component: LegacyRenderComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      name: 'Estágios',
      legacyRoute: 'estagios/visualizar.aspx',
      roles: ['Administrador da Empresa'],
      permissions: {
        only: 'InternshipModuleAccess',
        redirectTo: '/unauthorized'
      },
      icon: 'graduation-cap',
      notInHeaderMenu: true,
    }
  },
  {
    path: 'agreements', component: LegacyRenderComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      name: 'Convênios',
      legacyRoute: 'm/convenio/empresa',
      roles: ['Administrador da Empresa'],
      permissions: {
        only: 'AgreementModuleAccess',
        redirectTo: '/unauthorized'
      },
      icon: 'check-square-o'
    }
  },
  {
    path: 'documents', component: LegacyRenderComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      name: 'Documentos',
      legacyRoute: 'm/documentos/empresa',
      roles: ['Administrador da Empresa'],
      permissions: {
        redirectTo: '/unauthorized'
      },
      icon: 'file'
    }
  },

  {
    path: 'change-password', component: LegacyRenderComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      name: 'Alterar senha',
      legacyRoute: 'comuns/trocasenhausuario.aspx',
      roles: ['Administrador da Empresa'],
      permissions: {
        only: 'PasswordChange',
        redirectTo: '/unauthorized'
      },
      profileMenuItens: true,
      profileMenuItenOrder: 1
    },
  },
  {
    path: 'digital-password', component: LegacyRenderComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      name: 'Senha digital',
      legacyRoute: 'configuracoes/conta/senha-digital',
      roles: ['Administrador da Empresa'],
      permissions: {
        only: 'DigitalSignaturePasswordChange',
        redirectTo: '/unauthorized'
      },
      profileMenuItens: true,
      profileMenuItenOrder: 2
    },
  },
  {
    path: 'personal-data', component: LegacyRenderComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      name: 'Dados Pessoais',
      legacyRoute: 'comuns/dadosusuario.aspx',
      roles: ['Administrador da Empresa'],
      permissions: {
        redirectTo: '/unauthorized'
      },
      profileMenuItens: true,
      profileMenuItenOrder: 3
    },
  },
  {
    path: 'company-data', component: LegacyRenderComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      name: 'GERENCIAR EMPRESA',
      legacyRoute: 'empresa/responsaveislegais.aspx',
      roles: ['Administrador da Empresa'],
      permissions: {
        redirectTo: '/unauthorized'
      },
      profileMenuItens: true,
      profileMenuItenOrder: 4
    },
  },
  {
    path: 'privacy-policy',
    component: LegacyRenderComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      externalUrl: `https://www.symplicity.com/support/privacy-policy-pt`,
      name: 'Política de Privacidade',
      roles: ['Administrador da Empresa'],
      permissions: {
        only: 'PrivacyPolicyVisualize',
        redirectTo: '/unauthorized'
      },
      profileMenuItens: true,
      profileMenuItenOrder: 6
    },
  },
  {
    path: 'document',
    component: LegacyRenderComponent,
    data: {
      name: 'Documento',
      legacyRoute: 'estagio/documento',
      notInHeaderMenu: true,
      hideHeader: true,
      hideFooter: true
    },
  },
  {
    path: 'document/:id',
    component: LegacyRenderComponent,
    data: {
      name: 'Documento',
      legacyRoute: 'estagio/documento',
      notInHeaderMenu: true,
      hideHeader: true,
      hideFooter: true
    },
  },
  {
    path: 'document/:system/:type/:name/:id',
    component: LegacyRenderComponent,
    data: {
      name: 'Documento',
      legacyRoute: 'estagios/documentos',
      notInHeaderMenu: true,
      hideHeader: true,
      hideFooter: true
    },
  },
  {
    path: 'monitoring-document',
    component: LegacyRenderComponent,
    data: {
      name: 'Documento',
      legacyRoute: 'documentacao/templateacompanhamento.aspx',
      notInHeaderMenu: true,
      hideHeader: true,
      hideFooter: true
    },
  },
];